// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-detail-sidebar-documents {
  min-height: 100%;
  padding: 0 13px;
  width: 448px;
}

  .department-detail-sidebar-documents__thumbnails > * {
      display: inline-block;
      margin: 21px 13px;
      width: 185px;
    }
`, "",{"version":3,"sources":["webpack://./app/components/DepartmentDetailSidebar/components/DepartmentDetailSidebarDocuments/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AASd;;EANI;MACE,qBAAqB;MACrB,iBAAiB;MACjB,YAAY;IACd","sourcesContent":[".department-detail-sidebar-documents {\n  min-height: 100%;\n  padding: 0 13px;\n  width: 448px;\n\n  &__thumbnails {\n    & > * {\n      display: inline-block;\n      margin: 21px 13px;\n      width: 185px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
